// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications-eva{padding:0 0 40px 0}.notifications-eva .avatar-notifications{z-index:2;margin-top:-20px}.notifications-eva .message-notifications{background-color:#e3e3e3;font-family:\"GothamSSm-Book\",Arial,sans-serif;font-size:16px;color:#000000;padding:10px 15px;border-radius:15px;z-index:1}.notifications-eva .message-notifications p{margin:0;font-size:16px;line-height:20px}\n", ""]);
// Exports
module.exports = exports;
